import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ReportDeeplinkRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ReportDeeplinkResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const reportDeeplink = (request: ReportDeeplinkRequest, options?: CashRequestOptions) =>
  post<ReportDeeplinkRequest, ReportDeeplinkResponse>('/2.0/cash/report-deeplink', request, {
    ...options,
    rejectOnError: true,
  })
